export enum ClickAction {
  OPEN_MAP = "openMap", //default
  SEND_TO_SRP = "sendToSRP",
}
